import { Injectable } from '@angular/core';
import * as olExtent from 'ol/extent';
import { Subject } from 'rxjs';
import { AlertService } from './alert.service';
import { Coordinate } from 'ol/coordinate';
import { Geometry } from 'ol/geom';

@Injectable({
  providedIn: 'root'
})
export class MapUtilsService {

  private viewResolutions = [
    1058.3354500042335,
    529.1677250021168,
    211.667090000847,
    132.2919312505292,
    66.1459656252646,
    26.458386250105836,
    13.229193125052918,
    6.614596562526459,
    2.6458386250105836,
    1.3229193125052918,
    0.661459656252646,
    0.330729828126323,
    0.1653649140631615
  ];

  readonly hasWebGlSupport: boolean;

  constructor(private alertService: AlertService) {
    this.hasWebGlSupport = this.checkWebGLSupport();
  }

  getScaleForResolution(map, resolution) {
    var dpi = 25.4 / 0.28;
    var mpu = map.view.getProjection().getMetersPerUnit();
    var inchesPerMeter = 39.3701;
    return [(mpu * inchesPerMeter * dpi) * parseFloat(resolution), parseFloat(resolution) * (mpu * inchesPerMeter * 96)];
  }

  getZoomlevelForScale(map, scale) {
    var resolution = this.getResolutionForScale(map, scale);
    for (var i = 0; i < this.viewResolutions.length; i++) {
      if (this.viewResolutions[i] < resolution) {
        return (i === 0) ? 0 : i - 1;
        break;
      }
    }
    return this.viewResolutions.length;
  }

  getResolutionForScale(map, scale) {
    //standard 90,71 dpi
    //const dpi = 25.4 / 0.28;
    const mpu = map.getView().getProjection().getMetersPerUnit();
    const inchesPerMeter = 39.3701;
    //return parseFloat(scale) / (mpu * inchesPerMeter * dpi);
    return parseFloat(scale) / (mpu * inchesPerMeter * 96);
  }

  getBboxCenter(bbox: Geometry): Coordinate {
    return olExtent.getCenter(bbox.transform('EPSG:4326', 'EPSG:3857').getExtent());
  }

  private checkWebGLSupport() {
    let hasWebGLSupport = false;
    try {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl')
      hasWebGLSupport = !!(window.WebGLRenderingContext && gl);
      if (gl) {
        gl.getExtension("WEBGL_lose_context").loseContext();
      }
    } catch (e) {
    }
    return hasWebGLSupport;
  }

  // tileloadNotAuthorizedEvent$ = new Subject();
  // getTileloadFunction() {
  //   let customTileLoadFunction = (imageTile, src) => {
  //     var xhr = new XMLHttpRequest();
  //     xhr.responseType = 'blob';
  //     xhr.addEventListener('loadend',
  //       (evt) => {
  //         // console.dir(evt)
  //         if ((xhr.getResponseHeader('content-type').indexOf('image') === 0) && (xhr.response !== undefined)) {
  //           try {
  //             // console.log('goe bezig ')
  //             imageTile.getImage().src = URL.createObjectURL(xhr.response);

  //           } catch (error) {
  //             //ol.TileState.ERROR
  //             imageTile.setState(3);
  //           }
  //         } else {
  //           if (xhr.status === 401) {
  //             this.tileloadNotAuthorizedEvent$.next();
  //             //console.log('ai nee, dikke miserie');
  //             // show message
  //             // this.alertService.error("account.invalid_token", { "autoClose": true });
  //             // // log out after message              
  //             // window.setTimeout(() => {
  //             //   window.location.reload();
  //             // }, 1000);
  //           } else {
  //             //ol.TileState.ERROR
  //             imageTile.setState(3);
  //           }
  //         }
  //       }
  //     );

  //     xhr.addEventListener('error', function () {
  //       //ol.TileState.ERROR
  //       imageTile.setState(3);
  //     });
  //     xhr.open('GET', src);
  //     xhr.send();
  //   }

  //   return customTileLoadFunction

  // }
}
